import auth from './auth';
import profile from './profile';
import closeout from './closeout';
import comments from './comments';
import dependencies from './dependencies';
import grant from './grant';
import tasks from './tasks';
import snapshot from './snapshot';
import config from './config';
import template from './template';
import toggles from 'go/actions/api/toggles';
import dynamicData from './dynamicData';
import attachments from './attachments';
import application from './application';
import history from './history';
import organization from './organization';
import organizationRelationship from './organizationRelationship';
import commitment from './commitment';
import rules from './rules';
import vendor from './vendor';
import location from './location';
import program from './program';
import userEntities from 'go/actions/api/userEntities';
import subawardRecommendation from './subawardrecommendation';
import awardRecommendation from './awardRecommendation';
import disasterAreas from './disasterAreas';
import ehp from './ehp';
import subGrant from './subgrant';

export default {
  application,
  auth,
  profile,
  closeout,
  comments,
  grant,
  dependencies,
  tasks,
  snapshot,
  config,
  template,
  dynamicData,
  attachments,
  toggles,
  history,
  organization,
  organizationRelationship,
  commitment,
  rules,
  vendor,
  location,
  program,
  userEntities,
  subawardRecommendation,
  awardRecommendation,
  disasterAreas,
  ehp,
  subGrant
};
